<style lang="scss" src='./Management.scss' scoped></style>
<template src="./Management.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import Placeholder from '@/components/placeholders/Placeholders.vue';
import {
  getManagementCompanies,
  postManagementCompany,
  editManagementCompany
} from '@/api/index';
import i18n from './../../../../i18n';

import {
  mapState,
  mapActions,
  mapMutations,
} from 'vuex';

export default {
  name: 'Management',
  extends: SecurityComponent,
  components: {
    Placeholder,
  },
  data() {
    return {
      create: true,
      companiesAvailable: [],
      newActive: false,
      editCompany: null,
      companyName: null,
      loading: false,
    };
  },
  computed: {
    orderedCompanies() {
      if (this.companiesAvailable && this.companiesAvailable.length > 0) {
        let getName = this.getLabel;
        return this.companiesAvailable.sort(function(a, b) {
          var nameA = getName(a).toUpperCase(); // ignore upper and lowercase
          var nameB = getName(b).toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0;
        });
      }
    },
  },

  methods: {
    getLabel(item) {
      return item.company_name;
    },

    showNewModal() {
      this.newActive = true;
      this.companyName = null;
      this.$bvModal.show('modal-add-company')
    },

    showEditModal(item) {
      this.loading = false;
      this.editCompany = item;
      this.companyName = item.company_name;
      this.newActive = false;
      this.$bvModal.show('modal-add-company');
    },
    
    async saveCompany(){
      this.loading = true;
      if(this.companyName){

        let data = {
          name: this.companyName,
        };

        if(this.newActive) {

          postManagementCompany(data).then((resp)=>{
            this.loadData();
            this.$bvModal.hide('modal-add-company');
          })
        } else {
          editManagementCompany(data, this.editCompany.company_id).then((resp)=>{
            this.loadData();
            this.$bvModal.hide('modal-add-company');
          })
        }

        this.loading = false;
      }
    },

    async loadData() {
      this.loadAvailableCompanies();
    },

    loadAvailableCompanies() {
      getManagementCompanies().then((resp) => {
        if (resp.management_companies && resp.management_companies.length) {
          this.companiesAvailable = resp.management_companies.map(company => ({...company, selected: false}));
        } else {
          this.companiesAvailable = [];
        }
      })
    },
  },
  async mounted() {
    if (process.env.VUE_APP_SENTRY_ENV == "production") {
      this.$analytics.setCurrentScreen("Web Settings Companies");
      this.$analytics.logEvent("web_settings_companies");
    }

    this.loadData();
  },
};

</script>
